import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { LandingPage } from './components/LandingPage';
import { PrescriptionUpload } from './components/PrescriptionUpload';
import { AnalysisResults } from './components/AnalysisResults';
import { AudioQRCode } from './components/AudioQRCode';
import { MedicineCabinet } from './components/MedicineCabinet';
import { PrescriptionView } from './components/PrescriptionView';
import { QRPrescriptionSchedule } from './components/QRPrescriptionSchedule';
import './styles/globals.css';
import './App.css';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route
              path="/upload"
              element={
                <PrescriptionUpload
                  onUploadSuccess={() => {
                    // Handle success
                  }}
                />
              }
            />
            <Route path="/analysis" element={<AnalysisResults />} />
            <Route path="/audio" element={<AudioQRCode />} />
            <Route path="/qr-schedule" element={<QRPrescriptionSchedule />} />
            <Route path="/cabinet" element={<MedicineCabinet />} />
            <Route path="/view/:prescriptionId" element={<PrescriptionView />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
